import { FormatType } from '@consts/wysiwyg';

type ContentType = {
  type: `${FormatType}`;
  text?: string;
  caption?: string;
  children?: ContentType[];
};

export const countWords = (content: string): number => {
  const words = content.trim().split(' ');
  return words.length;
};

export const countWordsInArticleContent = (content: ContentType[], count: number): number => {
  let wordCount = count;

  content.forEach((item) => {
    if (item.type !== 'htmlCode' && item.text) {
      wordCount += countWords(item.text);
    }

    if (item.caption) {
      wordCount += countWords(item.caption);
    }

    if (item.type !== 'htmlCode' && item.children) {
      wordCount = countWordsInArticleContent(item.children, wordCount);
    }
  });

  return wordCount;
};
